import script from "./EpisodeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EpisodeCard.vue?vue&type=script&setup=true&lang=ts"

import "./EpisodeCard.vue?vue&type=style&index=0&id=5aafcd09&lang=scss"

const __exports__ = script;

export default __exports__